import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const OffertKategori = lazy(() => import("@/pages/info/OffertKategori"));

export const Route = createFileRoute("/kommersiella-solceller/")({
  head: () => seoHead("/kommersiella-solceller", { description: "Solcellsanläggningar för företag, lantbruk och fastighetsägare. Få kostnadsfria offerter på takanläggningar och markanläggningar." }),
  component: () => <OffertKategori slug="kommersiella-solceller" />,
});
